<template>
  <div>
    <div class="container-fluid page-head-wrap">
      <div class="container page-head text-center">
        <p class=" questionnaire-subhead mb-0 d-inline-block"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <trans-text i18nKey="ui[7][101]"/></p>
        <p class="mb-0" v-if="apiLoading"><i class="fa fa-spinner fa-pulse fa-fw" style="font-size: 14px; "></i> <trans-text i18nKey="ui['5_4_1'][101]"/></p>
      </div>
    </div>

  <div class="container">
    <div class="row">
      <page-content :cart="cart" :cartPhotos="cartPhotos" :isShowCartPhotoSizePopoverForm="isShowCartPhotoSizePopoverForm" :totalCount="totalCount" :totalPrice="totalPrice"
      @toggleIsShowCartPhotoSizePopoverForm="toggleIsShowCartPhotoSizePopoverForm" @refleshTotal="refleshTotal" @refleshEventPrice="refleshEventPrice" :eventPrices="eventPrices"
      @hideIsShowCartPhotoSizePopoverForm="hideIsShowCartPhotoSizePopoverForm"
      ></page-content>

    </div>
  </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import PageContent from 'page/partials/Order/Cart/PageContent.vue'

  import Event from 'processor/Event'
  import Cart from 'processor/Cart'

  export default {
    name:"",
    components: {
      PageContent,
    },
    data () {
      return {
        eventPrices:{},
        totalCount:0,
        totalPrice:0,
        cart:{},
        cartPhotos:{},
        isShowCartPhotoSizePopoverForm:false,
        apiLoading:true,
      }
    },
    computed:{
      isMobileBreakpoint(){
        switch(this.$root.bootstrapBreakpoint){
          case "xl":
          case "lg":
            return false
          case "md":
          case "sm":
          case "xs":
            return true
          default:
            return null
        }
      },

    },
    beforeRouteLeave (to, from, next) {
      this.isShowCartPhotoSizePopoverForm = false
      this.$nextTick(function () {
        next()
      });
    },
    mounted(){
      Cart.cartPreparation()
        .then((res) => {
          if (res.status === "ng") {
            this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
            return
          }
          this.cart = res.data.cart
          return Cart.getCartPhotos({"cart_id":this.cart.id})
        })
        .then((res) => {
          if (res.status === "ng") {
            this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
            return
          }
          this.cartPhotos = res.data.cart_photos
          this.refleshTotal()
          this.refleshEventPrice()
          this.apiLoading=false
        })
    },
    methods:{
      refleshTotal(){
        app.make("axios").get(`v1/cart-total-price`,{})
          .then(({data}) =>{
//            this.totalCount = 0
//            this.totalPrice = 0
            this.totalCount = data.count
            this.totalPrice = data.total_price
          })
          .catch(error => {
          })
      },
      refleshEventPrice(){
        app.make("axios").get(`v1/cart-event-price`,{})
          .then(({data}) =>{
            this.eventPrices = data
          })
          .catch(error => {
          })
      },
      toggleIsShowCartPhotoSizePopoverForm(){
        this.isShowCartPhotoSizePopoverForm = !this.isShowCartPhotoSizePopoverForm
      },
      hideIsShowCartPhotoSizePopoverForm(){
        this.isShowCartPhotoSizePopoverForm=false
      }
    }
  }
</script>


<style lang="scss" scoped>
  .questionnaire-subhead{
    padding:.1rem 1rem;
    font-size: 1.2rem;
    border: 1px solid #000;
    background-color: #ffffc1;
  }
</style>



// WEBPACK FOOTER //
// Cart.vue?6cca1aed